import { heroComics } from "@/mocks/comics";

const stats = [
  { value: "1200+", label: "原版韩漫资源" },
  { value: "日更 200+", label: "每日更新章节" },
  { value: "98.6%", label: "读者满意度" },
  { value: "50 万+", label: "尊享注册读者" },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[92vh] items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20dark%20luxury%20manga%20comic%20book%20collage%20background%2C%20floating%20open%20comic%20pages%20with%20ink%20brush%20strokes%20and%20golden%20particles%2C%20deep%20warm%20black%20and%20amber%20gold%20tones%2C%20dramatic%20cinematic%20lighting%2C%20abstract%20artistic%20illustration%2C%20elegant%20and%20premium%20atmosphere&width=1800&height=1100&seq=hero-bg-main&orientation=landscape"
          alt="韩漫土豪漫画网尊享阅读背景"
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/85 via-background-950/70 to-background-950"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 pt-28 md:px-6 md:pb-24 md:pt-32">
        <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-500/50 bg-primary-500/10 px-4 py-1.5 text-xs font-medium text-primary-300">
              <i className="ri-vip-crown-2-line"></i>
              土豪专属 · 尊享阅读平台
            </div>

            <h1 className="font-heading text-3xl font-black leading-tight text-foreground-50 md:text-5xl">
              韩漫<span className="text-gradient-gold">土豪</span>漫画网
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-foreground-300 md:text-lg">
              专注原版韩漫资源，VIP 章节付费解锁抢先看。尊享高画质、无广告的纯净阅读体验，热门连载每日更新，分类齐全，只为满足你的尊享阅读需求。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#hot"
                className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-center text-sm font-bold text-background-950 transition-colors hover:bg-primary-400"
              >
                开启免费阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#pricing"
                className="whitespace-nowrap rounded-md border border-foreground-300/30 bg-background-800/40 px-7 py-3 text-center text-sm font-bold text-foreground-100 backdrop-blur transition-colors hover:border-primary-500/60 hover:text-primary-300"
              >
                查看尊享套餐
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-2 gap-x-4 gap-y-6 border-t border-background-700/50 pt-7 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label}>
                  <dt className="sr-only">{s.label}</dt>
                  <dd className="font-heading text-xl font-bold text-primary-300 md:text-2xl">
                    {s.value}
                  </dd>
                  <dd className="mt-1 text-xs text-foreground-400">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="relative hidden lg:block">
            <div className="grid grid-cols-3 gap-3">
              {heroComics.map((c, i) => (
                <a
                  key={c.id}
                  href="#hot"
                  className={`group relative overflow-hidden rounded-lg border border-background-600/60 ${i === 1 || i === 2 ? "mt-8" : ""}`}
                >
                  <img
                    src={c.cover}
                    alt={`${c.title}韩漫封面`}
                    className="aspect-[3/4] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/90 to-transparent p-2.5 pt-8">
                    <p className="text-xs font-medium text-foreground-50">{c.title}</p>
                    <p className="mt-0.5 text-[11px] text-primary-300">第{c.chapters}话更新中</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute bottom-6 left-1/2 z-10 hidden -translate-x-1/2 md:block">
        <a href="#vip" aria-label="向下滚动" className="flex h-10 w-6 items-start justify-center rounded-full border border-foreground-400/40 p-1.5">
          <span className="h-2 w-1 animate-bounce rounded-full bg-primary-400"></span>
        </a>
      </div>
    </section>
  );
}